import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";


const gridLocation = 'activityConfigList';

@observer
export default class ActivityConfigList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Activity Config`;
  static icon = 'send';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("ActivityConfigList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation)
    });

  }


  render() {
    let {params, query} = this.props;

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}>
          <ZzFlatButtonRoute onGridToolbar routeName="activityConfigDetail" params={{id: 'new'}} label="New Activity Config" permission={PERMISSION.New} securable={PAGE.activityConfigDetail}/>
        </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/core/event/activityConfigList.tsx